package com.anjuros.website.templates.template9.modules

import com.anjuros.website.templates.template9.util.Template9CompanyDetails
import com.anjuros.website.templates.template9.util.Template9Constants
import com.anjuros.website.templates.template9.util.Template9Res

enum class Template9Contact(
    val icon: String,
    val alt: String,
    val contact: Template9CompanyDetails,
    val path: String
) {
    PHONE(
        icon = Template9Res.Icon.phone,
        alt = "phone",
        contact = Template9CompanyDetails.CLIENTS_PHONE_INFO,
        path = "tel:${Template9Constants.CLIENTS_PHONE}"
    ),
    EMAIL(
        icon = Template9Res.Icon.email,
        alt = "email",
        contact = Template9CompanyDetails.CLIENTS_EMAIL_INFO,
        path = "mailto:${Template9Constants.CLIENTS_EMAIL}"
    ),
    AREA(
        icon = Template9Res.Icon.location,
        alt = "service area",
        contact = Template9CompanyDetails.CLIENTS_SERVICE_AREA_INFO,
        path = Template9Constants.CLIENTS_MAP
    )
}

enum class Template9Social(
    val icon: String,
    val alt: String,
    val path: String
) {
    FACEBOOK(
        icon = Template9Res.Icon.facebook,
        alt = "facebook",
        path = Template9Constants.CLIENTS_FACEBOOK_PATH
    ),
    INSTAGRAM(
        icon = Template9Res.Icon.instagram,
        alt = "instagram",
        path = Template9Constants.CLIENTS_INSTAGRAM_PATH
    )
}
